export const SET_PHONE_CALL_DETAILS = 'SET_PHONE_CALL_DETAILS'
export const SET_DATA_FOR_RECENT_CALLS_TABLE = 'SET_DATA_FOR_RECENT_CALLS_TABLE'
export const SAVE_DATA_FOR_ACTIVITY = 'SAVE_DATA_FOR_ACTIVITY'
export const SET_TIMELINE_DATA = 'SET_TIMELINE_DATA'
export const SET_ACTIVITY_ID = 'SET_ACTIVITY_ID'
export const TIMELINE_DATA_LOADING = 'TIMELINE_DATA_LOADING'
